type RowType =
  | "START"
  | "HARDSTOP"
  | "SOFTSTOP"
  | "IGNORE"
  | "ANCHOR"
  | "NORMAL";

const rowTypeKeys: RowType[] = [
  "START",
  "HARDSTOP",
  "SOFTSTOP",
  "IGNORE",
  "ANCHOR",
  "NORMAL",
];

const isRowType = (value: string): value is RowType =>
  rowTypeKeys.indexOf(value as RowType) > -1;

const getRowTypes = () => [...rowTypeKeys];

/**
 * Efficiently check if rowType is 'START', 'SOFTSTOP', 'HARDSTOP', 'IGNORE'.
 * @param x object with rowType property
 * @returns true if rowType is a Table Body Row
 */
const isBodyRow = function isBodyRow(x: { rowType: RowType }): boolean {
  return x.rowType === "NORMAL" || x.rowType === "ANCHOR";
};

export { RowType, isRowType, getRowTypes, isBodyRow };
